import { render } from "./EmployeeFormFields.vue?vue&type=template&id=1880425c&scoped=true"
import script from "./EmployeeFormFields.vue?vue&type=script&lang=ts"
export * from "./EmployeeFormFields.vue?vue&type=script&lang=ts"

import "./EmployeeFormFields.vue?vue&type=style&index=0&id=1880425c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1880425c"

export default script